import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'Util/refluxConnector';
import { translate as _l } from 'oxygen-i18n';
import { Units } from 'Css';
import {
  List,
  RaisedButton,
  ListItem,
  IconButton,
  TextField
} from 'material-ui';
import UploadDialog from 'components/MediaLibrary/UploadDialog';
import * as SvgIcons from 'components/Material/SvgIcons';
import CourseActions from 'actions/Course';
import debounce from 'oxygen-debounce';

addTranslations({
  ['en-US']: {
    Diploma: 'Diploma',
    'Drop a pdf here': 'Drop a pdf here',
    Upload: 'Upload',
    Remove: 'Remove',
    'Add diploma template': 'Add diploma template',
    'Retrieve a test diploma': 'Retrieve a test diploma',
    'Percentage finished to be eligible for a diploma':
    'Percentage finished to be eligible for a diploma',
  },
  ['sv-SE']: {
    Diploma: 'Intyg',
    'Drop a pdf here': 'Dra och släpp en pdf här',
    Upload: 'Ladda upp',
    Remove: 'Ta bort',
    'Add diploma template': 'Lägg till en intygsmall',
    'Retrieve a test diploma': 'Få ett exempel på kursintyget',
    'Percentage finished to be eligible for a diploma':
      'Sätt en procent som deltagaren måste ha tagit del av för att få intyg'
  }
});

const styles = {
  list: {
    paddingTop: 32,
    backgroundColor: '#FFFFFF'
  },
  listHeader: {
    fontSize: 24,
    borderStyle: 'none none solid none',
    borderWidth: '1px',
    borderColor: 'rgba(0, 0, 0, 0.12)'
  }
};

const css = oxygenCss({
  header: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '48px',
    paddingLeft: 16,
    borderStyle: 'none none solid none',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.12)'
  },
  content: {
    padding: 16
  },
  buttonWrapper: {
    padding: 16
  },
  panel: {
    textAlign: 'center',
    padding: Units.keyline / 2
  }
});

class CourseDiplomaEditor extends Component {
  static propTypes = {
    children: PropTypes.node,
    course: PropTypes.object,
    save: PropTypes.func,
    update: PropTypes.func,
    remove: PropTypes.func,
    retrieveTest: PropTypes.func
  };

  constructor(props){
    super(props);
    const settings = this.props.course.settings || {};
    const diploma = settings.diploma || {};
    this.state = {
      fileSelectorOpen: false,
      progress: 0,
      passPercentage: diploma.passPercentage || 80
    }
  }

  openFileSelector = () => this.setState({ fileSelectorOpen: true });
  closeFileSelector = () => this.setState({ fileSelectorOpen: false });
  progress = event => this.setState({ progress: event.pervent });
  openUpload = () => this.dropZone.open();
  retrieveTest = () => {
    const { course, retrieveTest } = this.props;
    retrieveTest(course.id);
  };
  add = (url, id) => {
    const { update } = this.props;
    update({ fileId: id, passPercentage: 80 });
    this.closeFileSelector();
    this.save();
  };
  remove = () => {
    const { remove, course } = this.props;
    remove(course.id);
  };
  handlePassPercentageChange = event => {
    const { value: passPercentage } = event.target;
    const { update } = this.props;
    this.setState({ passPercentage })
    if (!isNaN(parseInt(passPercentage))) {
      update({ passPercentage: parseInt(passPercentage) });
      this.save();
    }
  };
  save = debounce(() => {
    const { save } = this.props;
    save();
  }, 300);

  render() {
    const { fileSelectorOpen } = this.state;
    const { course } = this.props;
    const settings = course.settings || {};
    const hasDiploma = settings.diploma && settings.diploma.fileId;
    const removeButton = (
      <IconButton
        onTouchTap={this.remove}
        tooltip={_l`Remove`}
        tooltipPosition="top-left"
      >
        <SvgIcons.ContentClear />
      </IconButton>
    );
    return (
      <List
        subheader={_l`Diploma`}
        style={styles.list}
        subheaderStyle={styles.listHeader}
      >
        {hasDiploma && (
          <ListItem
            primaryText={_l`Diploma`}
            leftIcon={<SvgIcons.FileFolder />}
            rightIconButton={removeButton}
          />
        )}
        {hasDiploma && (
          <div className={css.buttonWrapper}>
            <TextField
              fullWidth
              floatingLabelText={_l`Percentage finished to be eligible for a diploma`}
              value={this.state.passPercentage}
              onChange={this.handlePassPercentageChange}
            />
          </div>
        )}
        {!hasDiploma && (
          <div className={css.buttonWrapper}>
            <RaisedButton
              onTouchTap={this.openFileSelector}
              fullWidth
            >{_l`Add diploma template`}</RaisedButton>
          </div>
        )}
        {hasDiploma && (
          <div className={css.buttonWrapper}>
            <RaisedButton
              onTouchTap={this.retrieveTest}
              fullWidth
            >{_l`Retrieve a test diploma`}</RaisedButton>
          </div>
        )}
        <UploadDialog
          onRequestClose={this.closeFileSelector}
          onSuccess={this.add}
          title={_l`Upload`}
          description={_l`Drop a pdf here`}
          type="pdf"
          open={fileSelectorOpen}
        />
      </List>
    );
  }
}

export default connect([], {
  update: CourseActions.updateDiploma,
  remove: CourseActions.removeDiploma,
  save: CourseActions.saveSettings,
  retrieveTest: CourseActions.retrieveDiploma
})(CourseDiplomaEditor);

//{courseId: }

//php ./worker run IssueCertificate '{"file_id":140548,"user_id":11329$,"course_id":1565}'



// WEBPACK FOOTER //
// ./src/js/containers/CourseDiplomaEditor.js